module.exports = __webpack_public_path__ + "Roboto-Light.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Light.eot
// module id = 231
// module chunks = 2